export default "__VITE_ASSET__CQz5pITn__"